import React, { useState, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

interface TextEditorProps {
  value: string;
  onChange: (content: string) => void;
  onBlur?: (range: any, source: any, editor: any) => void;
  error?: string;
  helperText?: string;
}

// Register custom fonts
const Font = Quill.import("formats/font");
Font.whitelist = ["Arial", "Roboto", "Vazir", "IranSans"];
Quill.register(Font, true);

const TextEditor: React.FC<TextEditorProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
}) => {
  const [isRtl] = useState(false);
  const quillRef = useRef<ReactQuill | null>(null);

  // Define modules with additional toolbar options
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headers H1 to H6
      [{ font: [] }], // Font selection
      [{ size: ["small", "medium", "large", "huge"] }], // Font sizes
      ["bold", "italic", "underline", "strike"], // Text styling
      [{ script: "sub" }, { script: "super" }], // Subscript and Superscript
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      [{ align: [] }, { direction: "rtl" }], // Text alignment and direction
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      [{ color: [] }, { background: [] }], // Text color and background color
      ["link", "image", "video", "blockquote", "code-block"], // Media and formatting options
      ["clean"], // Remove formatting
    ],
  };

  // Define formats for the editor
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "script",
    "list",
    "bullet",
    "align",
    "direction",
    "indent",
    "color",
    "background",
    "lineheight",
    "link",
    "image",
    "video",
    "blockquote",
    "code-block",
  ];

  return (
    <div className="mb-6 mt-6 w-full h-[650px] relative border-none">
      {/* Toggle RTL/LTR button */}

      {/* Text Editor */}
      <ReactQuill
        ref={quillRef}
        className={`h-[530px] md:h-[600px] rounded w-full border-none${
          error ? "border border-red-500" : ""
        }`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        modules={modules}
        formats={formats}
        style={{
          textAlign: isRtl ? "right" : "left",
          direction: isRtl ? "rtl" : "ltr",
        }}
      />
      {(error || helperText) && (
        <p className="text-right w-full text-[9px] text-mobasher-red mt-1 absolute -bottom-[12px] right-0">
          * {error || helperText}
        </p>
      )}
    </div>
  );
};

export default TextEditor;
